/**
 * Marker the video confirmation sets on the way back to the actions page, so that page knows the
 * supporter already recorded (`supporter_voices_video_first`, arms v1_emotional/v3_impact).
 *
 * Lives here rather than beside the rest of the flow's contract in
 * `shared/utils/supporterVoicesFlow` because the actions page needs the raw key, not a function:
 * it reads the value with `useClearedQueryParamValue`, which both reads and strips it. Everything
 * else about the contract is expressed as functions and stays in that module.
 */
export const SUPPORTER_VOICE_ENTRY_PARAM = 'supporter_voice';
